import $ from "jquery";
$(document).on('turbolinks:load', () => {
  $('#wallet-amount-converter #transaction_amount').change(() => {
    const wallet_amount = parseFloat($('#transaction_amount').val());
    $.ajax({
      type: "GET",
      url: `/admin/transactions/wallet_currency_to_dollars`,
      data: {amount: wallet_amount},
      success: (data) => {
        $('#transaction_dollars').val(parseFloat(data.dollars_amount));
      },
      error: () => {
        alert('An error occurred while computing values.');
        $('#transaction_dollars').val('');
      }
    });
  });

  $('#wallet-amount-converter #transaction_dollars').change(() => {
    const dollars_amount = parseFloat($('#transaction_dollars').val());
    $.ajax({
      type: "GET",
      url: `/admin/transactions/dollars_to_wallet_currency`,
      data: {amount: dollars_amount},
      success: (data) => {
        $('#transaction_amount').val(parseFloat(data.wallet_currency_amount));
      },
      error: () => {
        alert('An error occurred while computing values.');
        $('#transaction_amount').val('');
      }
    });
  });
});